import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { FetchService } from '@services/fetch.service';

@Injectable({
  providedIn: 'root',
})
export class KeyService {
  public key: Observable<any>;

  constructor(private fetchService: FetchService) {
    this.key = this.getKey();
    this.key.subscribe();
  }

  private getKey(): Observable<any> {
    return this.fetchService.json('/assets/config/key.json').pipe(
      catchError(() => {
        return of({ key: '' });
      }),
      shareReplay(1)
    );
  }
}
